import styles from './TenantSelector.module.css';
import type { TenantSyncModeSelectorProps } from './types';

const DRAFT_DEFAULT_BADGE = 'Default for new';
const ALL_TENANTS_TITLE = 'All tenants (current and new)';

export function TenantSyncModeSelector({
  mode,
  onModeChange,
  excludedTenantCount,
  includeDraftOption,
  allTenantsSelectionDescription,
  selectedTenantsSelectionDescription,
  draftSelectionDescription,
  disabled,
}: TenantSyncModeSelectorProps) {
  const allTenantsTitle =
    excludedTenantCount > 0
      ? `${ALL_TENANTS_TITLE} · ${excludedTenantCount} excluded`
      : ALL_TENANTS_TITLE;

  return (
    <fieldset className={styles.modeOptions}>
      {includeDraftOption && (
        <label>
          <input
            type="radio"
            name="tenant-sync-mode"
            checked={mode === 'draft'}
            onChange={() => onModeChange('draft')}
            disabled={disabled}
          />
          <span className={styles.modeHeader}>
            <span className={styles.modeTitle}>Keep as draft</span>
            <span className={styles.modeBadge}>{DRAFT_DEFAULT_BADGE}</span>
          </span>
          <span className={styles.modeDescription}>{draftSelectionDescription}</span>
        </label>
      )}
      <label>
        <input
          type="radio"
          name="tenant-sync-mode"
          checked={mode === 'all'}
          onChange={() => onModeChange('all')}
          disabled={disabled}
        />
        <span className={styles.modeTitle}>{allTenantsTitle}</span>
        <span className={styles.modeDescription}>{allTenantsSelectionDescription}</span>
      </label>
      <label>
        <input
          type="radio"
          name="tenant-sync-mode"
          checked={mode === 'selected'}
          onChange={() => onModeChange('selected')}
          disabled={disabled}
        />
        <span className={styles.modeTitle}>Selected tenants only</span>
        <span className={styles.modeDescription}>{selectedTenantsSelectionDescription}</span>
      </label>
    </fieldset>
  );
}
